import { getMetadata } from '../selectors/metadata';

import { useAppSelector } from './redux';

export const useMetadata = (pathname: string) => useAppSelector(getMetadata(pathname));
